import { filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import Speech from 'speak-tts' // es6
import { TranslateService } from './translate.service';

@Injectable({ providedIn: 'root' })
export class VaniService {
  speech;
  show = false;
  constructor(private translate: TranslateService) {
    this.speech = new Speech();

    if (this.speech.hasBrowserSupport()) {
      // console.log("Speech synthesis supported");

      this.speech.init({
        lang: 'hi-IN',
        volume: 1,
        rate: .8,
        pitch: 1,
        splitSentences: true,
        listeners: {
          onvoiceschanged: (voices) => {
            voices = voices.filter(x => x.lang == 'hi-IN');
            // console.log("Voices available:", voices.length);
            for (let voice of voices) {
              // console.log(voice);
            }

            // ✅ Pick a Hindi voice if available
            const hindiVoice = voices.find(v => v.lang === 'hi-IN');
            if (hindiVoice) {
              this.speech.setVoice(hindiVoice.name);
              // console.log("Selected Hindi voice:", hindiVoice.name);
            } else {
              // console.warn("No Hindi voice found, falling back to default");
            }
          }
        }
      }).then(data => {
        // console.log("Speech ready", data);
      }).catch(e => {
        // console.error("Init error:", e);
      });

    } else {
      // console.log("Speech synthesis NOT supported in this browser");
    }
  }

  read(text) {
    return new Promise((resolve) => {

      // console.log(this.show, this.speech.speaking());
      if (this.show) {
        text = this.translate.translate(text);
        // console.log(text);
        if (!this.speech.speaking()) {
          // speechSynthesis.onvoiceschanged = () => {
            this.speech.speak({
              text: text,
              queue: true, // current speech will be interrupted,
              listeners: {
                onstart: () => {
                  // console.log("Start utterance")
                },
                onend: () => {
                  // console.log("End utterance")
                },
                onresume: () => {
                  // console.log("Resume utterance")
                },
                onboundary: (event) => {
                  // console.log(event.name + ' boundary reached after ' + event.elapsedTime + ' milliseconds.')
                }
              }
            }).then(() => {
              // console.log("Success !")
              resolve(true);
            }).catch(e => {
              // console.error("An error occurred :", e)
              resolve(false);
            })
          // }
        } else {
          // console.error("Already speaking")
        }
      }
    })

  }
}